export class DiveAT {
  constructor() { }
  commonStep = 'stepper.form.commun.divers.step';
  step = 'stepper.form.dive_at.step';
}
